export default {
  pagination: {},
  lesson: null,
  lessons: [],
  files: []
};
